import * as React from "react";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Link,
    List,
    ListItem,
    ListItemText,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel, TextField,
} from "@material-ui/core";
// import Popover from '@material-ui/core/Popover';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Tooltip from "@material-ui/core/Tooltip";
import { useActions } from "../actions";
import * as GiftorActions from "../actions/giftor";
import * as DocusignActions from "../actions/docusign";
import * as Actions from "../actions/enrollment";
import * as TicketActions from "../actions/ticket";
import { ActionItems as CurrentActionsItems, ClientDocumentType, ServicingActionTypes } from "../constants";
import AdministratorMessage from "./client/ClientProfile/component/modals/AdministratorMessage";
import RequestModification from "./client/ClientProfile/component/modals/RequestModification";
import ResetPayment from "./client/ClientProfile/component/modals/ResetPayment";
import { UploadProposalPopUp } from "../components/client/Proposal";
import PaymentReceivedPopUp from "../components/client/PaymentReceivedPopUp";
import PaymentProcessedPopUp from "../components/client/PaymentProcessedPopUp";
import * as AccountActions from "../actions/account";
import DocusignLoader from "../components/DocusignLoader";
import { Dialog as GenericDialog, GenericDialogProps } from "../components/dialog";
import { Button as CustomMuiButton, Label } from "../components/formInputs";
import * as Aws from "../actions/aws";
import { AccountSortList } from "../model/account";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { CreateTicketDialog } from "./ticket/CreateTicket";
import { TicketDetailDialog } from "./ticket/TicketPage";
import UploadSpecificDocument from "./client/ClientProfile/component/dialogs/UploadSpecificDocument";
import ActionItemListRow from "../components/ActionItemListRow";
import { joinAsFullName, noop, pez, va } from "../utils/commonUtils";
import { Proposal } from "../model/proposal";
import { ClientDocsInterface } from "../model/documents";
import LoaderGif from "../styles/images/loader_nw.gif";
import { isAllianzApp } from "./client/Enrollment/EnrollmentHome/EnrollmentApplication/Utilities";
import * as ApplicationActions from "../actions/application";
import QCPopUp from "../components/client/Proposal/ActionDailogs/QCPopUp/QCPopUp";
import CheckWirePopup from "../components/client/Proposal/ActionDailogs/CheckWirePopup/CheckWire";
import DocuSign from "../components/Common/DocuSign";
import RejectChangingRequest from "../components/clientServicing/admin/components/RejectChangingRequest";
import * as clientActions from "../actions/client";
import VerticalDotsPopover from "./VerticalDotsPopover";
import { history } from "../configureStore";
import { Global } from "../utils/commonFunc";
import TrusteeRejectServicingRequest
    from "../components/clientServicing/admin/components/TrusteeRejectServicingRequest";
import { ProposalDialog } from "../components/ProposalDialogs";
import AdminOverrideDialog from "./AdminOverrideDialog";
import RequestModel from "../components/clientServicing/admin/components/RequestModel";

import ApproveBankPopup from "../components/clientServicing/Payments/ApproveBankPopup";
import {ViewIllustrationRequest} from "../components/RequestChanges";
import { PolicyContextProvider } from "../components/clientServicing/Payments/PolicyContext";
import ConfirmPaymentDetails from "./ConfirmPaymentDetails";


export const actionItemAndServiceRequestMapper = {
    [CurrentActionsItems.UPDATE_LEGAL_NAME.actionType]: "editLegalName",
    [CurrentActionsItems.UPDATE_PERSONAL_DETAIL.actionType]: "editPersonal",
    [CurrentActionsItems.UPDATE_BENEFICIARY.actionType]: "editBeneficiary",
    [CurrentActionsItems.TRUSTEE_REJECTED_BENEFICIARY.actionType]: "editBeneficiary",
    [CurrentActionsItems.TRUSTEE_REJECTED_NAME_CHANGE.actionType]: "editLegalName",
}

const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                width: "100%",
                marginTop: theme.spacing(3),
            },
            paper: {
                padding: 5,
            },
            table: {
                minWidth: 750,
            },
            tableWrapper: {
                overflowX: "auto",
            },
            visuallyHidden: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: 1,
                margin: -1,
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                top: 20,
                width: 1,
            },
            closeButton: {
                position: "absolute",
                right: theme.spacing(1),
                top: theme.spacing(1),
                color: theme.palette.grey[500],
            },
            popover: {
                pointerEvents: "none",
            },
            buttonProgress: {
                color: "white",
            },
        }),
);
const styles: any = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: "10px",
        top: "20px",
        color: theme.palette.grey[500],
    },
});


function ActionItemsList(props: any) {
    const initFalse = false;
    const SEPARATOR: string = '|||||';
    const DialogTitle: any = withStyles(styles)((props: any) => {
        const { children, classes, onClose, type, userName, ...other } = props;
        return (
                <MuiDialogTitle disableTypography className={classes.root} {...other}>
                    <Typography variant="h6">{children}</Typography>
                    {onClose ? (
                            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                    ) : null}
                </MuiDialogTitle>
        );
    });
    const accountActions = useActions(AccountActions);
    const docusignActions = useActions(DocusignActions);
    const giftorActions = useActions(GiftorActions);
    const enrollmentActions = useActions(Actions);
    const ticketActions = useActions(TicketActions);
    const applicationActions = useActions(ApplicationActions);
    const awsActions = useActions(Aws);
    const [isOpen, setIsOpen] = React.useState(false);
    const classes = useStyles();
    let {
        actionItemsList,
        order,
        orderBy,
        headRows,
        role,
        getEnvelope,
        userName,
        type,
        value,
        refreshPage,
        onRequestSort,
        setFilterType,
        mockSetComplete,
        isViaAgentApprovalPage,
    } = props;

    const [onViewIllustrationRequest, setViewIllustrationRequest] = React.useState<any>(false);
    const [activeProposalTab, setActiveProposalTab] = React.useState(0);
    const [enableActions, setEnableActions] = React.useState(true);
    const [openProposalPdf, setOpenProposalPdf] = React.useState<Proposal[]>([] as Proposal[]);
    const [actionId, setActionId] = React.useState(0);
    const [enrollmentId, setEnrollmentId] = React.useState("");
    const [adminMessage, setAdminMessage] = React.useState(false);
    const [requestModification, setRequestModification] = React.useState(false);
    const [resetPayment, setResetPayment] = React.useState(false);
    const [documentUrl, setDocumentUrl] = React.useState("");
    const [openPdf, setOpenPdf] = React.useState(false);
    const [inProgress, setInProgress] = React.useState(true);
    const [uploadProposalPopUp, setUploadProposalPopUp] = React.useState(false);
    const [QCPopUpOpen, setQCPopUpOpen] = React.useState(false);
    const [CheckWirePopUpOpen, setCheckWirePopUpOpen] = React.useState(false);
    const [paymentReceivedPopUp, setPaymentReceivedPopUp] = React.useState(false);
    const [paymentProcessedPopUp, setPaymentProcessedPopUp] = React.useState(false);
    const [clientUserId, setClientUserId] = React.useState("");
    const [client, setClient] = React.useState(null);
    const [clientPolicy, setClientPolicy] = React.useState(null);
    const [clientId, setClientId] = React.useState(0);
    const [clientPolicyId, setClientPolicyId] = React.useState<string>("");
    const [agentId, setAgentId] = React.useState(0);
    const [downloadProgress, setDownloadProgress] = React.useState({ enrollmentId: "" });
    const [sellerAgreementLoading, setSellerAgreementLoading] = React.useState(false);
    const [sellerAgreementActionId, setSellerAgreementActionId] = React.useState(0);
    const [sellerAgreement, setSellerAgreement] = React.useState(false);
    const [sellerAgreementUrl, setSellerAgreementUrl] = React.useState('');
    const [actionItemSelected, setActionItemSelected] = React.useState(null);
    const [coverLetterDialog, setCoverLetterDialog] = React.useState(false);
    const [coverLetterUpload, setCoverLetterUpload] = React.useState(true);
    const [clientDetail, setClientDetail] = React.useState<any>(null);
    const [viewApproveProposal, setViewApproveProposal] = React.useState(false);
    const [viewServicingDocs, setViewServicingDocs] = React.useState('');
    const [changingRequest, setChangingRequest] = React.useState(false);
    const [serviceDocusignUrl, setServiceDocusignUrl] = React.useState<any>("");
    const { servicingUpdateReqDocusign, updateServicingActionItems } = useActions(clientActions);
    const ServicingRejectPopUp = role == 12 ? TrusteeRejectServicingRequest :  RejectChangingRequest
    const [wetConfirmationPopUp, setWetConfirmationPopUp] = React.useState(false);
    const [gwtChangingRequest, setGwtChangingRequest] = React.useState(false);
    const [gwtChangingRequestType, setGwtChangingRequestType] = React.useState("additionalDocs");
    const [gwtDocChangeTitle, setGwtDocChangeTitle] = React.useState("");
    const [gwtDocChangeDesc, setGwtDocChangeDesc] = React.useState("");

    const [actionType, setActionType] = React.useState<string>("");
    const [actionPayload, setActionPayload] = React.useState("");

    const [confirmPaymentPopUP, setConfirmPaymentPopUP] = React.useState(false);

    // const classes = useStyles();
//     const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

//     const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//       setAnchorEl(event.currentTarget);
//     };
  
//     const handleClose2 = () => {
//       setAnchorEl(null);
//     };
//     const open = Boolean(anchorEl);
//   const id = open ? 'simple-popover' : undefined;


    let actionItemsListData: any = actionItemsList.rows && actionItemsList.rows.length > 0 && actionItemsList.rows.map((row: any) => {
        row.agent = row.agent ? row.agent : (row.client && row.client.clientPolicies && row.client.clientPolicies.length > 0 && row.client.clientPolicies[0].agent ? row.client.clientPolicies[0].agent : null);
        return row;
    });
    const [ openDoc ,setOpenDoc] = React.useState(false);
    const [paymentFrequency, setPaymentFrequency] = React.useState<string>("");

    // TODO use common getEnrollmentAdminProposalUrl
    const getEnrollmentAdminProposalUrl = async (eId: string, adminProposal: string) => {
        let file = adminProposal.split(".");
        let fileType = file[file.length - 1].toUpperCase();
        const contentType = (fileType == "PDF") ? ("text/pdf") : ("image/*");
        let queryObj = {
            objectName: adminProposal,
            contentType: contentType,
        };
        return awsActions.getSecureUrl(eId, queryObj, true);
    }

    const viewProposal = async (id: number, eId: string, status: number, clientPolicy: any) => {
        const documents: any[] = await accountActions.getClientDocumentByType((clientPolicy && clientPolicy.id) || 0, ClientDocumentType.ADMIN_PROPOSAL);
        const proposalArr: Proposal[] = [];
        for (let i = 0; i < documents.length; i++) {
            const proposalDocument = documents[i] as ClientDocsInterface;
            const url = await getEnrollmentAdminProposalUrl(eId, pez(proposalDocument.path));
            proposalArr.push({ name: proposalDocument.name, url: url });
        }
        setClientPolicyId(clientPolicy && clientPolicy.id);
        setActiveProposalTab(0);
        setOpenProposalPdf(proposalArr);
        setEnrollmentId(eId);
        setActionId(status === 1 ? 0 : id);
        setPaymentFrequency((clientPolicy && clientPolicy.paymentFrequency) || "annual");
    };

    const getDocusign = async (userId: string, requestType: string, clientPolicyId: string) => {
        const res = await servicingUpdateReqDocusign({userId, clientPolicyId}, requestType ,true)
        if(res.success){
            setOpenDoc(true)
            setServiceDocusignUrl(res.data.envelopeUrl)
        }
    }

    const RequestForChangesButton =  ({ account, buttonText, actionType, clientId, clientPolicyId, setClientId, setClientDetail, role }: any) => {
        const requestType = actionItemAndServiceRequestMapper[account.actionType];
        const userId = account.client.userId;
        return (
                <><Button
                        size="small"
                        variant="contained"
                        color="primary"
                        className="floatRight btnSmall ml5"
                        type={"button"}
                        onClick={async () => {
                            setViewServicingDocs(actionType);
                            setChangingRequest(true);
                            setClientId(clientId);
                            setClientPolicyId(clientPolicyId);
                        }

                        }
                >
                    {buttonText}
                </Button>
                    <VerticalDotsPopover>
                        <List component="nav">
                            <ListItem button>
                                <ListItemText onClick={() => {
                                    setWetConfirmationPopUp(true);
                                }} primary="Approve Wet Sign Changes" />
                            </ListItem>
                        </List>
                    </VerticalDotsPopover>
                </>
        );

    }

    const ServicingButton = ({ account, buttonText, actionType, clientId, clientPolicyId, setClientId, setClientDetail, role }: any) => {
        const requestType = actionItemAndServiceRequestMapper[account.actionType];
        const userId = account.client.userId;
        const showVerticalDotsPopover = ![CurrentActionsItems.UPDATE_CLIENT_DOCUMENTS.actionType].includes(actionType)
        return (
                <> <div className={`${ showVerticalDotsPopover && "displayF"} `}>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        className={`${ showVerticalDotsPopover ? " floatLeft" : "floatRight" } btnSmall ml5`}
                        type={"button"}
                        disabled={[CurrentActionsItems.TRUSTEE_REJECTED_BENEFICIARY.actionType].includes(actionType)}
                        onClick={async () => {
                            if(role == 12 || [ServicingActionTypes.UPDATE_BENEFICIARY, CurrentActionsItems.TRUSTEE_REJECTED_BENEFICIARY.actionType ].includes(actionType)){
                                await getDocusign(userId, requestType, clientPolicyId)
                                Global.set("onApproveRequest", approveServicingRequestFunction(clientId, clientPolicyId, account.actionType))
                            }else{
                                history.push(`/new-client/detail/${clientId}/${clientPolicyId}/documents`)
                            }
                        }}
                >
                    {buttonText}
                    {/*{downloadProgress.enrollmentId === ((account && account.enrollmentId) || enrollmentId) &&*/}
                    {/*        <CircularProgress size={24}*/}
                    {/*                          className={classes.buttonProgress} />}*/}
                </Button>
                    {
                            showVerticalDotsPopover &&
                            <VerticalDotsPopover>
                                <List component="nav">
                                    <ListItem button>
                                        <ListItemText onClick={() => {
                                            setViewServicingDocs(actionType);
                                            setChangingRequest(true);
                                            setClientId(clientId);
                                            setClientPolicyId(clientPolicyId);
                                        }} primary="Request New Changes" />
                                    </ListItem>
                                </List>
                            </VerticalDotsPopover>
                    }
                </div>
                </>
        );
    }

    //Get Envelope for Admin
    const getAdminEnvelope = async (enrollmentId: string, offerType?: any) => {
        setOpenPdf(true);
        let envelopeUrl = "";
        if (isAllianzApp(offerType)) {
            const result = await applicationActions.getAndInitiateDocusign(enrollmentId);
            if (result) {
                envelopeUrl = result.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        } else {
            let pageUrl = window.location.protocol + "//" + window.location.hostname;
            if (window.location.hostname === "localhost") {
                pageUrl = pageUrl + ":3000";
            }
            pageUrl += "/new-client-detail/thanks?isAdminApprove=1";
            let result = await enrollmentActions.getEnvelope(enrollmentId, pageUrl);
            if (result && result && result.payload.data) {
                envelopeUrl = result.payload.data.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        }
    };

    const getAdminChildEnvelope = async (envelopeId: string) => {
        setOpenPdf(true);
        let envelopeUrl = "";
        const result = await giftorActions.getAdminChildDocusign(envelopeId);
        if (result) {
            envelopeUrl = result.url;
            setDocumentUrl(envelopeUrl);
            setInProgress(false);
        }
    };

    const approveProposal = async () => {
        await enrollmentActions.updateEnrollmentProposalActionItem({ enrollmentId, actionId });
        setOpenProposalPdf([]);
        setActiveProposalTab(0);
        setActionId(0);
        refreshPage();
    };

    const cancelProposal = () => {
        setOpenProposalPdf([]);
        setActiveProposalTab(0);
        setActionId(0);
    };

    const handleAdministratorMessage = () => {
        setAdminMessage(true);
    };

    const handleRequestModification = (enrollmentId: any) => {
        setRequestModification(!requestModification);
        setEnrollmentId(enrollmentId || 0);
    };

    const handleResetPayment = () => {
        setResetPayment(true);
    };

    const handleClose = async () => {
        setAdminMessage(false);
        setRequestModification(false);
        setResetPayment(false);
        if (typeof refreshPage === "function") {
            refreshPage();
            return;
        }
        await accountActions.getFreshDataToRefreshReduxState();
    };

    const handleCloseRm = async () => {
        setRequestModification(false);
    };

    const loadSellerAgreement = async (agentId: number, actionId: number, sellerAgreementId: number) => {
        setSellerAgreement(!initFalse);
        setSellerAgreementLoading(!initFalse);
        setSellerAgreementActionId(actionId);
        let pageUrl = window.location.protocol + "//" + window.location.hostname;
        if (window.location.hostname === "localhost") {
            pageUrl = pageUrl + ":3000";
        }
        pageUrl += `/new-client-detail/thanks?isAdminApproveSellerAgreement=1&sellerAgreementId=${sellerAgreementId}&sellerAgreementActionId=${actionId}`;
        const res = await docusignActions.getSellerAgreement(agentId, pageUrl);
        setSellerAgreementLoading(initFalse);
        setSellerAgreementUrl(res.envelopeUrl);
    };

    const sellerAgreementClose = async () => {
        setSellerAgreement(initFalse);
        setSellerAgreementLoading(initFalse);
        if (mockSetComplete && typeof mockSetComplete === "function") {
            mockSetComplete(sellerAgreementActionId);
        }
        setSellerAgreementActionId(0);
        return setSellerAgreementUrl('');
    };

    const getEnvelopeForTrustee = async (enrollmentId: string, offerType?: any, reqType?: string) => {
        setOpenPdf(true);
        let envelopeUrl = "";
        if (isAllianzApp(offerType)) {
            const result = await applicationActions.getAndInitiateDocusign(enrollmentId, reqType);
            if (result) {
                envelopeUrl = result.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        } else {
            let pageUrl = window.location.protocol + "//" + window.location.hostname;
            if (window.location.hostname === "localhost") {
                pageUrl = pageUrl + ":3000";
            }
            pageUrl += "/new-client-detail/thanks?isUploadTrusteeDocs=1";
            let result = await enrollmentActions.getEnvelope(enrollmentId, pageUrl);
            if (result && result && result.payload.data) {
                envelopeUrl = result.payload.data.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        }
    };

    const getEnvelopeForSignTrusteeDoc = async (enrollmentId: string, offerType?: any, reqType?: string) => {
        setOpenPdf(true);
        let envelopeUrl = "";
        if (isAllianzApp(offerType)) {
            const result = await applicationActions.getAndInitiateDocusign(enrollmentId, reqType);
            if (result) {
                envelopeUrl = result.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        } else {
            let pageUrl = window.location.protocol + "//" + window.location.hostname;
            if (window.location.hostname === "localhost") {
                pageUrl = pageUrl + ":3000";
            }
            pageUrl += "/new-client-detail/thanks?isSignTrusteeDoc=1";
            let result = await enrollmentActions.getEnvelope(enrollmentId, pageUrl);
            if (result && result && result.payload.data) {
                envelopeUrl = result.payload.data.envelopeUrl;
                setDocumentUrl(envelopeUrl);
                setInProgress(false);
            }
        }
    };

    const downloadEnvelope = async (enrollmentId: string, recipientId?: number) => {
        setDownloadProgress({ enrollmentId: enrollmentId });
        let result = await enrollmentActions.downloadEnvelope(enrollmentId, recipientId);
        if (result && result && result.payload.data) {
            let response: any = result.payload.data.fileBuf;
            let blob = new Blob([new Buffer(response, "binary")]
                    , { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = window.document.createElement("a");
            link.href = url;
            link.setAttribute("download", "application.pdf");
            window.document.body.appendChild(link);
            link.click();
            const payloadTrustee = {
                enrollmentId,
                actionType: "DOWNLOAD_TRUSTEE_DOCUMENTS",
            };
            await accountActions.updateTrusteeActionItemsStatus(payloadTrustee, "Document downloaded Successfully.");
            await accountActions.getFreshDataToRefreshReduxState();
            setDownloadProgress({ enrollmentId: "" });
        }
    };

    const getAdminButton = (actionType: string, buttonText: string = "", role: number, account: any, offerType?: any) => {
        const clientPolicyId = account && account.clientPolicyId;

        if (account && (account.status === 1 || account.status === 2) && actionType !== CurrentActionsItems.DOWNLOAD_TRUSTEE_DOCUMENTS.actionType) {
            return account.actionRequired;
        }

        if (actionType === CurrentActionsItems.UPLOAD_PROPOSAL.actionType && role !== 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                setEnrollmentId((account && account.enrollmentId) || 0);
                                setAgentId((account && account.agent && account.agent.id) || 0);
                                setClient((account && account.client) || 0);
                                setClientId((account && account.client && account.client.id) || 0);
                                setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                                setActionId(account.id);
                                setUploadProposalPopUp(true);
                                setClientPolicy((account && account.clientPolicy) || 0)
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if ((actionType === CurrentActionsItems.APPROVE_DOCUSIGN.actionType) && role !== 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                getAdminEnvelope((account && account.enrollmentId) || enrollmentId, offerType);
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if (actionType === CurrentActionsItems.QC_EPAY.actionType || actionType === CurrentActionsItems.QC_EPAY_SERVICE.actionType) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                if (account.actionPayload) {
                                    setActionPayload(JSON.parse(account.actionPayload));
                                }
                                setEnrollmentId((account && account.enrollmentId) || 0);
                                setAgentId((account && account.agent && account.agent.id) || 0);
                                setClient((account && account.client) || 0);
                                setClientId((account && account.client && account.client.id) || 0);
                                setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                                setQCPopUpOpen(true)
                                setActionType(actionType)
                                setClientPolicy((account && account.clientPolicy) || 0)
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if (actionType === CurrentActionsItems.CHECK_WIRE.actionType) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                setEnrollmentId((account && account.enrollmentId) || 0);
                                setAgentId((account && account.agent && account.agent.id) || 0);
                                setClient((account && account.client) || 0);
                                setClientId((account && account.client && account.client.id) || 0);
                                setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                                setCheckWirePopUpOpen(true);
                                setClientPolicy((account && account.clientPolicy) || 0)
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if (actionType === CurrentActionsItems.MAKE_PAYMENT_RECEIVED.actionType) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                setEnrollmentId((account && account.enrollmentId) || 0);
                                setAgentId((account && account.agent && account.agent.id) || 0);
                                setClient((account && account.client) || 0);
                                setClientId((account && account.client && account.client.id) || 0);
                                setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                                setPaymentReceivedPopUp(true);
                                setClientPolicy((account && account.clientPolicy) || 0)
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if (actionType === CurrentActionsItems.MARK_PAYMENT_PROCESSED.actionType) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => {
                                setEnrollmentId((account && account.enrollmentId) || 0);
                                setAgentId((account && account.agent && account.agent.id) || 0);
                                setClient((account && account.client) || 0);
                                setClientId((account && account.client && account.client.id) || 0);
                                setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                                setPaymentProcessedPopUp(true);
                                setClientPolicy((account && account.clientPolicy) || 0)
                            }}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if ((actionType === CurrentActionsItems.UPLOAD_TRUSTEE_FINAL_DOCS.actionType) && role !== 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => getEnvelopeForTrustee((account && account.enrollmentId) || enrollmentId, offerType, "illustration")}
                    >
                        {buttonText}
                    </Button>
            );
        }

        // SIGN_TRUSTEE_DOCUMENTS
        if (actionType === CurrentActionsItems.SIGN_TRUSTEE_DOCUMENTS.actionType && role == 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => getEnvelopeForSignTrusteeDoc((account && account.enrollmentId) || enrollmentId, offerType)}
                    >
                        {buttonText}
                    </Button>
            );
        }

        if (actionType === CurrentActionsItems.SIGN_TRUSTEE_ILLUSTRATION.actionType && role == 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => getEnvelopeForSignTrusteeDoc((account && account.enrollmentId) || enrollmentId, offerType, "illustration")}
                    >
                        {buttonText}
                    </Button>
            );
        }

        // DOWNLOAD_TRUSTEE_DOCUMENTS
        if (actionType === CurrentActionsItems.DOWNLOAD_TRUSTEE_DOCUMENTS.actionType && role == 12) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="floatRight btnSmall ml5"
                            type={"button"}
                            onClick={() => downloadEnvelope((account && account.enrollmentId) || enrollmentId, 6)}
                    >
                        {buttonText}
                        {downloadProgress.enrollmentId === ((account && account.enrollmentId) || enrollmentId) &&
                                <CircularProgress size={24}
                                                  className={classes.buttonProgress} />}
                    </Button>
            );
        }

        // UPDATE_BENEFICIARY || UPDATE_PERSONAL_DETAIL || UPDATE_LEGAL_NAME
        if ( [CurrentActionsItems.UPDATE_BENEFICIARY.actionType, CurrentActionsItems.UPDATE_PERSONAL_DETAIL.actionType, CurrentActionsItems.UPDATE_LEGAL_NAME.actionType, CurrentActionsItems.TRUSTEE_REJECTED_NAME_CHANGE.actionType, CurrentActionsItems.UPDATE_CLIENT_DOCUMENTS.actionType].includes(actionType) && (role == 1 || role == 2 || role == 12 || role === 3)) {
            return (

                        <ServicingButton account={account}
                                         buttonText={buttonText}
                                         actionType={actionType}
                                         clientId={((account && account.client && account.client.id) || 0)}
                                         clientPolicyId={clientPolicyId}
                                         setClientId={setClientId}
                                         setClientDetail={setClientDetail}
                                         role={role}
                        />

            );
        }

        if ( [CurrentActionsItems.TRUSTEE_REJECTED_BENEFICIARY.actionType].includes(actionType) && (role == 1 || role == 2 || role == 12 || role === 3)) {
            return (
                    <div className="displayF">
                        <AdminOverrideDialog open={wetConfirmationPopUp} onClose={() => {
                            setWetConfirmationPopUp(false);
                        }} onConfirm={() => {
                            wetApproveServicingRequestFunction(clientId, clientPolicyId, account.actionType);
                        }} />
                        <RequestForChangesButton account={account}
                                         buttonText={"Request New Changes"}
                                         actionType={actionType}
                                         clientId={((account && account.client && account.client.id) || 0)}
                                         clientPolicyId={clientPolicyId}
                                         setClientId={setClientId}
                                         setClientDetail={setClientDetail}
                                         role={role}
                        />
                    </div>
            );
        }

        //mark_documents_approved
        if (actionType === CurrentActionsItems.MARK_DOCUMENTS_APPROVED.actionType && (role == 1 || role == 2)) {
            return (
                    <>
                        <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                className="floatRight btnSmall ml5"
                                disabled={true}
                                type={"button"}
                                onClick={() => {
                                }}
                        >
                            Mark Documents Approved
                        </Button>
                        <Link variant="body1" className="mb0 mt5 ml15 floatRight"
                              onClick={() => props.history.push(`/new-client/detail/${account.client && account.client.id}/${clientPolicyId}/documents`)}>
                            View documents</Link>
                    </>
            );
        }

        if (actionType === CurrentActionsItems.APPROVE_GWT_CLIENT.actionType && (role == 1 || role == 2)) {
            return (
                    <>
                        <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                className="btnSmall ml5"
                                type={"button"}
                                onClick={async () => {getAdminChildEnvelope(account.envelopeId)}}
                        >
                            {buttonText}
                        </Button>
                        <VerticalDotsPopover>
                            <List component="nav">
                                <ListItem button>
                                    <ListItemText
                                            onClick={() => {
                                            setGwtChangingRequestType("additionalDocs");
                                            setGwtChangingRequest(true);
                                            setClientId((account && account.client && account.client.id) || 0);
                                            setClientPolicyId(clientPolicyId);
                                            setGwtDocChangeTitle("Request Supporting Documents")
                                            setGwtDocChangeDesc("What would you like to tell the client? if there is a specific documents needed, state that here.")
                                    }}
                                    primary="Request New Changes" />
                                </ListItem>
                                <ListItem button>
                                    <ListItemText
                                            onClick={() => {
                                                setGwtChangingRequestType("rejection");
                                                setGwtChangingRequest(true);
                                                setClientId((account && account.client && account.client.id) || 0);
                                                setClientPolicyId(clientPolicyId);
                                                setGwtDocChangeTitle("Reason for rejection")
                                                setGwtDocChangeDesc("")
                                            }}
                                    primary="Reject GWT Docs" />
                                </ListItem>
                            </List>
                        </VerticalDotsPopover>
                    </>
            );
        }

        //change bank account action type
        if (actionType === CurrentActionsItems.APPROVE_PAYMENT_METHOD.actionType && (role == 1 || role == 2)) {
            return (
                <>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        className="btnSmall"
                        type={"button"}
                        onClick={() => {
                            setEnrollmentId((account && account.enrollmentId) || 0);
                            setAgentId((account && account.agent && account.agent.id) || 0);
                            setClient((account && account.client) || 0);
                            setClientId((account && account.client && account.client.id) || 0);
                            setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                            setActionPayload((account && account.actionPayload) || 0)
                            setIsOpen(true)
                            setClientPolicy((account && account.clientPolicy) || 0)
                        }}
                    >
                        Approve Payment Method
                    </Button>
                    <PolicyContextProvider clientData={{clientPolicy:account.clientPolicy,...account.client}}>
                    {isOpen && <ApproveBankPopup
                        openPopup={isOpen}
                        actionPayload={actionPayload}
                        setOpenPopup={setIsOpen}
                        refreshList={refreshPage}
                        client={client}
                        enrollmentId={enrollmentId}
                        clientPolicy={clientPolicy}
                    />}
                    </PolicyContextProvider>
                </>
            );
        }

        //change bank account action type
        if (actionType === CurrentActionsItems.APPROVE_PAYMENT_METHOD.actionType && (role == 1 || role == 2)) {
            return (
                <>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        className="btnSmall"
                        type={"button"}
                        onClick={() => {
                            setEnrollmentId((account && account.enrollmentId) || 0);
                            setAgentId((account && account.agent && account.agent.id) || 0);
                            setClient((account && account.client) || 0);
                            setClientId((account && account.client && account.client.id) || 0);
                            setClientUserId((account && account.client && account.client.user && account.client.user.id) || "");
                            setActionPayload((account && account.actionPayload) || 0)
                            setIsOpen(true)
                            setClientPolicy((account && account.clientPolicy) || 0)
                        }}
                    >
                        Approve Payment Method
                    </Button>
                    <PolicyContextProvider clientData={{clientPolicy:account.clientPolicy,...account.client}}>
                    {isOpen && <ApproveBankPopup
                        openPopup={isOpen}
                        actionPayload={actionPayload}
                        setOpenPopup={setIsOpen}
                        refreshList={refreshPage}
                        client={client}
                        enrollmentId={enrollmentId}
                        clientPolicy={clientPolicy}
                    />}
                    </PolicyContextProvider>
                </>
            );
        }

        //clear Action item
        if (actionType === CurrentActionsItems.CLEAR_ACTION_ITEM.actionType && (role == 1 || role == 2)) {
            return (
                    <>
                        <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                className="floatRight btnSmall ml5"
                                type={"button"}
                                onClick={async () => {
                                    await accountActions.clearApprovalDocActionItem({ clientPolicyId: clientPolicyId });
                                    refreshPage();
                                }}
                        >
                            {buttonText}
                        </Button>
                    </>
            );
        }
        // cover letter required action item for admin
        if ((actionType === CurrentActionsItems.COVER_LETTER_REQUIRED.actionType ||
                actionType === CurrentActionsItems.TAX_DOCUMENT_INCOME_EARNER.actionType ||
                actionType === CurrentActionsItems.TAX_DOCUMENT_SPOUSE.actionType ||
                actionType === CurrentActionsItems.TAX_DOCUMENT_WEALTH_TRANSFER.actionType ) && (role == 1 || role == 2)) {
            return <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        if (account.status === 0) {
                            setClientDetail(account);
                            setTimeout(() => {
                                if (actionType !== "COVER_LETTER_REQUIRED") {
                                    setCoverLetterUpload(false);
                                }
                                setCoverLetterDialog(true);
                            }, 0);
                        }
                    }}
            >
                {CurrentActionsItems[actionType].actionButton}
            </Button>;
        }
        // approved_agent_seller_agreement_approval_for_admin
        if (actionType === CurrentActionsItems.AGENT_SELLER_AGREEMENT.actionType && (role == 1 || role == 2)) {
            return (
                    <CustomMuiButton
                            color="primary"
                            label={`Sign ${CurrentActionsItems[actionType].actionButton}`}
                            onClick={() => loadSellerAgreement(account.agent.id, account.id, account.agent.sellerAgreements[0].id)}
                            size="small"
                            variant="outlined"
                    />
            )
        }

        // Confirm Payment Details
        if (actionType === CurrentActionsItems.CONFIRM_PAYMENT_DETAILS.actionType && (role == 1 || role == 2)) {
            return (
                    <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={
                                () => {
                                    setConfirmPaymentPopUP(true);
                                    setEnrollmentId((account && account.enrollmentId) || 0);
                                    setClientPolicyId((account && account.clientPolicy && account.clientPolicy.id) || 0);
                                }}
                            >
                        {CurrentActionsItems.CONFIRM_PAYMENT_DETAILS.actionButton}
                    </Button>
            )
        }
    };

    const sellerCloseButtonProps = {
        id: "adminclosebtn",
        label: "Close",
        onClick: sellerAgreementClose,
        style: { display: "none" },
    };
    const sellerDialogProps: GenericDialogProps = {
        actions: (
                <Button {...sellerCloseButtonProps} />
        ),
        "aria-describedby": "seller-agreement-dialog",
        content: (
                <>
                    <div id="seller-agreement-dialog">
                        {
                                sellerAgreementLoading &&
                                <div className="mt30 textCenter">
                                    <img alt="Loading..." className="mb15" src={LoaderGif}/>
                                    <br/>
                                    <Typography variant="caption" className="w100">
                                        Signing document is being prepared. This could take some time so please be
                                        patient and don\'t close this window.
                                    </Typography>
                                </div>
                        }
                        <iframe
                                src={sellerAgreementUrl}
                                style={{width: "100%", height: "80vh"}}
                                title="seller-agreement-dialog"
                        />
                    </div>
                    <CustomMuiButton
                            id="viewer_iframe_confirm"
                            label="Confirm"
                            onClick={sellerAgreementClose}
                            style={{display: "none"}}
                    />
                </>
        ),
        fullWidth: !initFalse,
        keepMounted: !initFalse,
        maxWidth: "md",
        onClose: sellerAgreementClose,
        open: sellerAgreement,
        title: 'Approved Agent Selling Agreement',
    }

    const showPdfDialog = () => {

        return (
                <Dialog
                        fullWidth={true}
                        maxWidth={"lg"}
                        open={openPdf}
                        aria-labelledby="Enrollment Home"
                        aria-describedby="Enrollment process"
                ><DialogTitle id="customized-dialog-title">
                    View Documents
                    <IconButton aria-label="close" className={classes.closeButton} onClick={() => {
                        setDocumentUrl("");
                        setOpenPdf(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                    <DialogContent dividers>
                        <div id="alert-dialog-description" className="textCenter" style={{ height: "80vh" }}>
                            {inProgress ?
                                    <Grid container justify="center" spacing={2}>
                                        <Grid item xs={12} md={12} className="textCenter">
                                            <DocusignLoader />
                                        </Grid>
                                    </Grid>
                                    :
                                    <iframe
                                            className={"enrollmentIframe"}
                                            src={`${documentUrl}`}
                                            onLoad={noop}
                                            style={{width: "100%", height: "80vh"}}
                                    />
                            }
                        </div>
                    </DialogContent>
                    <DialogActions style={{ display: "none" }}>
                        <Button size="small" id={"closebtn"} color="primary" variant="contained"
                                className="mb20 mr30 mt15"
                                onClick={async () => {
                                    setDocumentUrl("");
                                    setOpenPdf(false);
                                    refreshPage();
                                    await accountActions.getFreshDataToRefreshReduxState();
                                }}
                                style={{ display: "none" }}
                        >
                            Close
                        </Button>
                        <Button size="small" id={"adminclosebtn"} color="primary" variant="contained"
                                className="mb20 mr30 mt15"
                                onClick={() => {
                                    setDocumentUrl("");
                                    setOpenPdf(false);
                                    refreshPage();
                                    setTimeout(() => accountActions.getFreshDataToRefreshReduxState(), 10000);
                                }}
                                style={{ display: "none" }}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        );
    };

    const showProposalPdfDialog = () => {
        return (
                <ProposalDialog
                        clientPolicyId={clientPolicyId}
                        activeProposalTab={activeProposalTab}
                        approvalVal={null}
                        approveProposal={approveProposal}
                        enableActions={enableActions}
                        handleRequestModification={handleRequestModification}
                        modificationVal={enrollmentId}
                        onClose={handleClose}
                        onRejectProposal={cancelProposal}
                        openProposalPdf=""
                        paymentFrequency={paymentFrequency}
                        proposalPdf={openProposalPdf}
                        setActiveProposalTab={setActiveProposalTab}
                        setEnableActions={setEnableActions}
                        setViewApproveProposal={setViewApproveProposal}
                        title="Client Proposal"
                        viewApproveProposal={viewApproveProposal}
                />
        );
    };

    const getRole = (role: number) => {
        if (role == 1 || role === 2) {
            return "Admin";
        }
        if (role == 3) {
            return "Imo";
        }
        if (role == 4) {
            return "Agent";
        }
        if (role == 12) {
            return "Trustee";
        }
        return "Client";
    };

    const getActionName = (account: any) => {
        let actionRequired: string = account.actionRequired;
        if (account && account.enrollmentNotes && account.enrollmentNotes.author) {
            actionRequired += " - " + account.enrollmentNotes.author.firstName + " " + account.enrollmentNotes.author.lastName + " (" + getRole(account.enrollmentNotes.author.role) + ")";
        }
        return actionRequired;
    };

    const createSortHandler = (property: keyof AccountSortList) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    const createTicket = async (actionItem, detail, files, clientPolicyId) => {
        try {
            setActionItemSelected(actionItem);
            await ticketActions.createTicket({
                actionItemId: actionItem.id,
                detail,
                files,
                clientPolicyId
            });
        } finally {
            setActionItemSelected(null);
            refreshPage();
        }
    };

    const resolveTicket = async (ticket) => {
        await ticketActions.resolveTicket(ticket.id);
        refreshPage();
    };

    const wetApproveServicingRequestFunction = async (clientId, clientPolicyId, actionType) => {
        await updateServicingActionItems({
            clientId: clientId,
            clientPolicyId: clientPolicyId,
            actionType: actionType,
            wetSign: true,
        });
        refreshPage();
    }

    const approveServicingRequestFunction = (clientId, clientPolicyId, actionType) => {
        return async () => {
            await updateServicingActionItems({
                clientId: clientId,
                clientPolicyId: clientPolicyId,
                actionType: actionType,
            });
            refreshPage();
        }
    }

    return (
            <React.Fragment>
                {showPdfDialog()}
                {
                    !!va(openProposalPdf) &&
                    showProposalPdfDialog()
                }
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/css/enrollmentCss.css`} />
                <TableHead>
                    <TableRow>
                        {headRows.map((row: any, idx: number) => (
                                <TableCell
                                        key={`${idx}-${row.id}`}
                                        padding={"default"}
                                        sortDirection={orderBy === row.id ? order : false}
                                >
                                    {(row.id === "createdAt" || row.id === "actionRequired") ?
                                            <TableSortLabel
                                                    active={orderBy === row.id}
                                                    direction={order}
                                                    onClick={createSortHandler(value === 1 && row.id === "createdAt" ? "updatedAt" : row.id)}
                                            >
                                                {(value === 1 && row.id === "createdAt" ? "Completed On" : row.label)}
                                                {orderBy === row.id ? (
                                                        <span className={classes.visuallyHidden}>
                                                            {order === "desc" ? "sorted descending" : "sorted ascending"}
                                                        </span>
                                                ) : null}
                                            </TableSortLabel>
                                            :
                                            (value === 1 && row.id === "createdAt" ? "Completed On" : row.label)
                                    }

                                </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                            (!actionItemsListData || actionItemsListData.length === 0)
                            && <TableRow>
                                <TableCell className="textLeft" colSpan={9}>
                                    No Action list
                                </TableCell>
                            </TableRow>
                    }

                    {
                            actionItemsListData && actionItemsListData.map((actionItem: any) => {
                                return <ActionItemListRow actionItem={actionItem} role={role} history={props.history}
                                                          getEnvelope={getEnvelope} getActionName={getActionName}
                                                          setClientDetail={setClientDetail}
                                                          type={type}
                                                          userName={userName}
                                                          actionItemSelected={actionItemSelected}
                                                          createTicket={createTicket}
                                                          isViaAgentApprovalPage={isViaAgentApprovalPage}
                                                          resolveTicket={resolveTicket}
                                                          viewProposal={viewProposal}
                                                          handleRequestModification={handleRequestModification}
                                                          getAdminButton={getAdminButton}
                                                          setCoverLetterDialog={setCoverLetterDialog}
                                                          setCoverLetterUpload={setCoverLetterUpload}
                                                          setViewIllustrationRequest={setViewIllustrationRequest}

                                />;
                            })
                    }
                </TableBody>

                <AdministratorMessage handleAdministratorMessage={handleAdministratorMessage} handleClose={handleClose}
                                      open={adminMessage} />
                <RequestModification
                        enrollmentId={enrollmentId}
                        handleClose={handleCloseRm}
                        open={requestModification}
                        role={role}
                />

                <ResetPayment handleDeclineEnrollment={handleResetPayment} handleClose={handleClose}
                              open={resetPayment} />
                {
                        (QCPopUpOpen) &&
                        <QCPopUp
                                actionPayload={actionPayload}
                                actionType={actionType}
                                refreshList={(updateListOnly: boolean) => refreshPage(updateListOnly)}
                                client={client}
                                setOpenPopup={setQCPopUpOpen}
                                openPopup={QCPopUpOpen}
                                enrollmentId={enrollmentId}
                                clientPolicy={clientPolicy}
                        />
                }
                {
                        (CheckWirePopUpOpen) &&
                        <CheckWirePopup
                                refreshList={() => refreshPage()}
                                client={client}
                                setOpenPopup={setCheckWirePopUpOpen}
                                openPopup={CheckWirePopUpOpen}
                                enrollmentId={enrollmentId}
                                clientPolicy={clientPolicy}
                        />
                }
                {
                        serviceDocusignUrl &&
                        <>
                            <DocuSign
                                    documentUrl={serviceDocusignUrl}
                                    openPdf={openDoc}
                                    onDocSignComplete={() => {
                                        Global.get("onApproveRequest") && Global.get("onApproveRequest")()
                                        Global.clear()
                                        setServiceDocusignUrl("");
                                    }}
                                    setOpenPdf={setOpenDoc}
                                    inProgress={false}
                            />
                        </>
                }
                {
                        changingRequest &&
                        <>
                            <ServicingRejectPopUp
                                    open={changingRequest}
                                    setChangingRequest={setChangingRequest}
                                    requestType={viewServicingDocs}
                                    clientId={clientId}
                                    clientPolicyId={clientPolicyId}
                                    refreshPage={refreshPage}
                            />
                        </>
                }
                {
                        (uploadProposalPopUp) &&
                        <UploadProposalPopUp
                                client={client}
                                clientId={clientId}
                                enrollmentId={enrollmentId}
                                open={uploadProposalPopUp}
                                refreshList={() => refreshPage()}
                                setUploadProposalPopUp={setUploadProposalPopUp}
                                actionId={actionId}
                                clientPolicy={clientPolicy}
                        />
                }
                {
                        paymentReceivedPopUp &&
                        <PolicyContextProvider clientData={{
                            clientPolicy: clientPolicy,
                            name: joinAsFullName((client && (client as any).user) as any),
                            email: (client && (client as any).user.email) as any,
                        }}>
                            <PaymentReceivedPopUp setPaymentReceivedPopUp={setPaymentReceivedPopUp}
                                                  open={paymentReceivedPopUp}
                                                  enrollmentId={enrollmentId}
                                                  agentId={agentId}
                                                  client={client}
                                                  refreshList={() => refreshPage()}
                                                  setFilterType={setFilterType}
                                                  role={role}
                                                  clientPolicy={clientPolicy}
                            />
                        </PolicyContextProvider>
                }
                {
                        paymentProcessedPopUp &&
                        <PaymentProcessedPopUp
                                setPaymentProcessedPopUp={setPaymentProcessedPopUp}
                                open={paymentProcessedPopUp}
                                enrollmentId={enrollmentId}
                                agentId={agentId}
                                client={client}
                                refreshList={() => refreshPage()}
                                setFilterType={setFilterType}
                                role={role}
                                clientPolicy={clientPolicy}
                        />
                }
                {
                        sellerAgreement &&
                        <GenericDialog {...sellerDialogProps} />
                }
                {
                        (coverLetterDialog && clientDetail) &&
                        <UploadSpecificDocument
                                clientDetail={clientDetail}
                                open={coverLetterDialog}
                                handleClose={async () => {
                                    setCoverLetterDialog(false);
                                    refreshPage();
                                }}
                                uploadCoverLetter={coverLetterUpload}
                                uploadAdditionalTaxDocs={!coverLetterUpload}
                                setCoverLetterReq={() => {
                                }}
                                coverLetterUploadedFromActionItem={coverLetterUpload}
                        />
                }
                {
                        onViewIllustrationRequest &&
                        <ViewIllustrationRequest
                                onViewIllustrationRequest={onViewIllustrationRequest}
                                refreshPage={refreshPage}
                                setViewIllustrationRequest={setViewIllustrationRequest}
                        />
                }

                {
                    gwtChangingRequest &&
                    <RequestModel
                        open={gwtChangingRequest}
                        setChangingRequest={setGwtChangingRequest}
                        requestType={gwtChangingRequestType as "rejection" | "additionalDocs"}
                        clientId={clientId}
                        clientPolicyId={clientPolicyId}
                        refreshPage={refreshPage}
                        title={gwtDocChangeTitle}
                        description={gwtDocChangeDesc}
                    />
                }


                <ConfirmPaymentDetails open={confirmPaymentPopUP} onClose={() => setConfirmPaymentPopUP(false)} enrollmentId={enrollmentId} clientPolicyId={clientPolicyId} refreshPage={refreshPage}/>

            </React.Fragment>
    );
}

export const TicketButton = ({ ticketId, onCreateTicket, disabled = false, onResolveTicket }) => {
    const exist = !!ticketId;

    const [isCreateTicketDialogOpen, setIsCreateTicketDialogOpen] = React.useState(false);
    const [ticketSelected, setTicketSelected] = React.useState<any>(null);


    const ticketActions = useActions(TicketActions);

    const handleClick = async () => {
        if (exist) {
            const ticket = await ticketActions.getTicket(ticketId);
            setTicketSelected(ticket);
        } else {
            setIsCreateTicketDialogOpen(true);
        }
    };


    const onCancel = () => setIsCreateTicketDialogOpen(false);
    const onOk = onCreateTicket;

    return (
            <>
                <Tooltip title={exist ? "" : "Create a Ticket"}>
                    <IconButton aria-label="ticket" onClick={handleClick} disabled={disabled}>
                        <ConfirmationNumberIcon color={exist ? "error" : "primary"} />
                    </IconButton>
                </Tooltip>
                <CreateTicketDialog
                        isDialogOpen={isCreateTicketDialogOpen}
                        onCancel={onCancel}
                        onOk={onOk}
                />
                {ticketSelected && (
                        <TicketDetailDialog
                                onClose={() => setTicketSelected(null)}
                                ticket={ticketSelected}
                                onResolveTicket={onResolveTicket}
                                isCompleted={ticketSelected.isResolved}
                        />
                )}
            </>
    );
};

// @ts-ignore
export default ActionItemsList;
